module.exports = __webpack_public_path__ + "static/novatel-logo-8de3b4ffbd60a487ff0686b76ac0f0e8.jpg";